import user from './local_storage/user';

export default {
    init() {
        const queryParams = window.location.search ? new URLSearchParams(window.location.search) : null;

        if (queryParams && queryParams.has('accountUpdate') && queryParams.get('accountUpdate') === 'success') {
            import(/* webpackChunkName: "toaster" */ '../toaster/toaster').then((component) => {
                component.default.display('success', 'Votre demande a bien été prise en compte.');
            });
        }

        const newsletterToasts = {
            updated: { type: 'success', message: 'Vos modifications ont été prises en compte.' },
            registered: { type: 'success', message: 'Votre inscription a été prise en compte.' },
            not_selected: { type: 'error', message: 'Au moins une newsletter doit être sélectionnée.' },
            error: { type: 'error', message: 'Vos préférences n’ont pas pu être enregistrées. Veuillez réessayer.' },
        };
        const newsletterToast = queryParams && newsletterToasts[queryParams.get('status')];
        if (newsletterToast) {
            import(/* webpackChunkName: "toaster" */ '../toaster/toaster').then((component) => {
                component.default.display(newsletterToast.type, newsletterToast.message);

                const url = new URL(window.location);
                url.searchParams.delete('status');
                window.history.replaceState(null, null, url);
            });
        }

        const message = sessionStorage.getItem('successFlowText');
        if (message) {
            import(/* webpackChunkName: "toaster" */ '../toaster/toaster').then((component) => {
                component.default.display('success', message);
            });

            sessionStorage.removeItem('successFlowText');
        }

        // Init connexion and save user in local storage
        user.init();
    },
};
